import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'tenant',
    {
        brandingUpdated:    custom({ scope: 'config' }),
        featureFlagChanged: custom({ scope: 'config' }),
    },
    { includeDefaultLifecycle: false },
);
